import { EmployerMarketSegment } from 'store/models/promoCodes';

export const segmentsMap: Map<string, EmployerMarketSegment | null> = new Map([
    ['Все', null],
    ['Micro', EmployerMarketSegment.Micro],
    ['Small', EmployerMarketSegment.Small],
    ['Medium', EmployerMarketSegment.Medium],
    ['Large', EmployerMarketSegment.Large],
    ['Premium', EmployerMarketSegment.Premium],
    ['Не определён', EmployerMarketSegment.Undefined],
]);

const reverseSegmentsMap = new Map<EmployerMarketSegment, string>();
for (const [key, value] of segmentsMap.entries()) {
    if (value !== null) {
        reverseSegmentsMap.set(value, key);
    }
}

export const getSelectedSegmentsToDTO = (selectedSegments: Set<string>): EmployerMarketSegment[] | null => {
    if (selectedSegments.has('Все') || selectedSegments.size === 0) {
        return null;
    }
    return [...selectedSegments].map((item) => {
        return segmentsMap.get(item);
    }) as EmployerMarketSegment[];
};

export const getSelectedSegmentsFromDTO = (segments: EmployerMarketSegment[] | null | undefined): Set<string> => {
    if (segments === null || !segments) {
        return new Set(['Все']);
    }

    const result = new Set<string>();

    for (const segmentValue of segments) {
        const key = reverseSegmentsMap.get(segmentValue);
        if (key !== undefined) {
            result.add(key);
        }
    }

    return result;
};
